"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateNoteDto = exports.CreateNoteDocumentDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class CreateNoteDocumentDto {
}
exports.CreateNoteDocumentDto = CreateNoteDocumentDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document ID",
        example: 1,
    }),
    (0, class_validator_1.IsInt)({ message: "Document ID must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Document ID is required." }),
    (0, class_validator_1.Min)(1, {
        message: "Document ID must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateNoteDocumentDto.prototype, "documentId", void 0);
class CreateNoteDto {
}
exports.CreateNoteDto = CreateNoteDto;
tslib_1.__decorate([
    (0, class_validator_1.IsInt)({ message: "Company id must be a number." }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Min)(1, {
        message: "Company id must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateNoteDto.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsInt)({ message: "Opportunity id must be a number." }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Min)(1, {
        message: "Opportunity id must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateNoteDto.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsInt)({ message: "Activity id must be a number." }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Min)(1, {
        message: "Activity id must be positive number.",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateNoteDto.prototype, "activityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Title",
        type: String,
        example: "Note title",
    }),
    (0, class_validator_1.IsString)({ message: "Title must be a string." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Title is required." }),
    (0, class_validator_1.MaxLength)(100, {
        message: "Title must not exceed 100 characters.",
    }),
    (0, class_transformer_1.Transform)(({ value }) => value ? value.trim() : value),
    tslib_1.__metadata("design:type", String)
], CreateNoteDto.prototype, "title", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Description",
        type: String,
        example: "Note description",
    }),
    (0, class_validator_1.IsString)({ message: "Description must be a string." }),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => value ? value.trim() : value),
    tslib_1.__metadata("design:type", String)
], CreateNoteDto.prototype, "description", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Note documents",
        type: [CreateNoteDocumentDto],
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)({ message: "Note documents must be an array." }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => CreateNoteDocumentDto),
    tslib_1.__metadata("design:type", Array)
], CreateNoteDto.prototype, "documents", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateNoteDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateNoteDto.prototype, "updatedBy", void 0);
